import {Cancel, CheckCircle} from '@mui/icons-material';
import {Alert, Typography} from '@mui/material';
import MarkdownContentRenderer from '../../../atoms/MarkdownContentRenderer/MarkdownContentRenderer';
import {Question} from '@cp/model';

export interface AdminQuestionReviewQuestionFeedbackProps {
  question: Question;
  isCorrect: boolean;
}

export default function AdminQuestionReviewQuestionFeedback({
  question,
  isCorrect,
}: AdminQuestionReviewQuestionFeedbackProps) {
  return (
    <Alert severity={isCorrect ? 'success' : 'error'} icon={isCorrect ? <CheckCircle /> : <Cancel />}>
      <Typography variant="body1" sx={{fontWeight: 600, mb: 1}}>
        {isCorrect ? 'Correct!' : 'Incorrect'}
      </Typography>
      {question.explanation && <MarkdownContentRenderer content={question.explanation} />}
    </Alert>
  );
}
